// extracted by mini-css-extract-plugin
export default {"root":"PageUsers_root__QjaIC","top":"PageUsers_top__yiM6P"};